import { FiCheck } from 'react-icons/fi';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';

const CAPABILITIES = [
  {
    title: 'Centralized user management',
    description:
      'Admins invite new team members by email — Piua AI generates a secure temporary password automatically and emails it directly to the new user.',
  },
  {
    title: 'Roles that match how your org works',
    description:
      'Every team member is either an Admin (manages users, billing, and org details) or a User (chats, scoped to their own account).',
  },
  {
    title: 'Suspend, reactivate, or remove access instantly',
    description:
      'Protected by a confirmation step so it\'s never accidental — without losing conversation history.',
  },
  {
    title: 'Organization-wide visibility',
    description: 'Admins see usage and privacy-filtering activity rolled up across the whole team, not just their own account.',
  },
  {
    title: 'Your organization\'s identity, managed centrally',
    description: 'Update your organization\'s name and billing email directly from account settings — no support ticket required.',
  },
  {
    title: 'Seats that grow with you',
    description: 'Enterprise supports up to 15 team members; Enterprise Advanced removes that limit entirely.',
  },
];

export default function TeamsSection() {
  return (
    <section className="py-24">
      <div className="container-page grid grid-cols-1 items-start gap-14 lg:grid-cols-[0.85fr_1.15fr]">
        <div className="flex flex-col gap-8">
          <SectionHeading
            align="left"
            eyebrow="Teams & enterprises"
            title="Dedicated tools for the people who manage the account"
            description="Piua AI scales from a single professional to an entire organization — with centralized administration built in from day one."
          />
          <Reveal delay={0.15}>
            <img
              src="/piua1.jpeg"
              alt="Two colleagues reviewing Piua AI together on a laptop and phone"
              className="w-full rounded-2xl border border-line object-cover shadow-card dark:border-midnight-600"
              loading="lazy"
            />
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {CAPABILITIES.map((item, index) => (
            <Reveal key={item.title} delay={index * 0.06} className="flex gap-3">
              <span className="mt-1 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-success/10 text-success">
                <FiCheck size={14} />
              </span>
              <div>
                <h3 className="text-sm font-bold text-ink dark:text-white">{item.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-muted dark:text-subtle">{item.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
